import { render, staticRenderFns } from "./bedchart-tabs.vue?vue&type=template&id=3597137b&scoped=true"
import script from "./bedchart-tabs.vue?vue&type=script&lang=js"
export * from "./bedchart-tabs.vue?vue&type=script&lang=js"
import style0 from "./bedchart-tabs.vue?vue&type=style&index=0&id=3597137b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597137b",
  null
  
)

export default component.exports